export const AdminEquipmentStaffNoteController = {
    store(): void {},
    destroy(): void {},
};
